/*
 * Copyright (c) 2017 Payoneer Germany GmbH. All rights reserved.
 */

/**
 * This component is used to update some layout in payment-widget
 * this layout does not include the form layout of networks and accounts
 */
var $ = require('jquery');
var groupService = require('./group.service');
var networksService = require('./networks.service');
var rootScope = require('./root-scope.service');
var domService = require('./dom.service');
var localize = require('./localize.service');
var handleServiceError = require('./handle-error.service');
var addOperationOptions = require('./operations.service');

/**
 * Change the icon when grouped networks
 * it shows the default one if smartSwitchSelectOne is false
 * or the icon related to newCode
 *
 * @param {string} newCode
 * @param {boolean} smartSwitch
 * @param {boolean} smartSwitchSelectOne
 */
function toggleIcons(newCode, smartSwitch, smartSwitchSelectOne) {
    $('label img').addClass('inactive');
    $('label img').removeClass('active');
    var smartSwitchableCode = groupService.getGroup(newCode, rootScope.getAllNetworks());
    if (smartSwitch && smartSwitchableCode && !smartSwitchSelectOne) {
        /* nothing found remove classes */
        var allImgs = $('#' + smartSwitchableCode + ' label img');
        allImgs.removeClass('inactive');
        allImgs.removeClass('active');
    } else {
        var foundImg = $('label img#' + newCode + '-logo').removeClass('inactive');

        foundImg.removeClass('inactive');
        foundImg.addClass('active');
    }
}

function addSelectedToLi(element) {
    $('.op-payment-widget-container >.list').removeClass('selected');
    element.parents('.list').addClass('selected');
}

/**
 * Update the label in case of grouped networks
 * @param {string} groupType group name
 * @param {object} network the network object, used to take the label
 */
function updateLabel(groupType, network) {
    var label = $('#' + groupType).find('label[defaultvalue]');
    var networkLabel;

    if (!network) {
        // retrieve the default value which is stored in the label's custom attribute called "defaultValue"
        networkLabel = label.attr('defaultvalue');
    } else {
        networkLabel = network.label;
    }

    label.text(networkLabel);
}
function saveTranslationObject(translation, bindingData) {
    rootScope.setTranslationObject(bindingData.newNetwork.networkCode, translation);
}
function switchMaxLengthOfCvv(translation, bindingData) {
    $('#' + bindingData.newNetwork.networkCode + 'form .verificationCode').attr(
        'maxlength',
        translation['account.verificationCode.length']
    );
}

function handleUpdateLang(err, translation, bindingData) {
    if (err) {
        return handleServiceError(err);
    }
    saveTranslationObject(translation, bindingData);
    switchMaxLengthOfCvv(translation, bindingData);
}

function removeOperationOptions() {
    $('.formContainerCREDIT_CARD .registration.options').remove();
}

function switchOperations(network) {
    var formContainer = $('.formContainerCREDIT_CARD');
    removeOperationOptions();
    addOperationOptions(network, formContainer);

    return;
}

/**
 * switch the forms update operations/checkbox values and set selectedNetwork
 * @param {string} code of the new network
 * @param {boolean} isIframe if it is selected native iframe or not
 */
function handleSmartSwitchForm(code, isIframe) {
    // if code is not null or "null" -> update operations and label of related group and set selected network
    var allNetworks = rootScope.getAllNetworks();
    if (code && code !== 'null') {
        toggleIcons(code, true, true);
        var newNetwork = networksService.getNetworkByCode(allNetworks, code);
        updateLabel(groupService.getGroup(code, allNetworks), newNetwork);
        if (rootScope.getSelectedNetworkCode() !== code) {
            switchOperations(newNetwork);
            rootScope.setSelectedNetwork(newNetwork);
            localize.load(newNetwork.links.lang, handleUpdateLang, {
                newNetwork: newNetwork,
                rootScope: rootScope,
            });
        }
    } else {
        // if code is null or "null" -> set label as default of group
        var groupTypeCode = groupService.getGroup(rootScope.getSelectedNetworkCode(), allNetworks);
        var smartSwitchDefaultCode = domService.getSmartSwitchCurrentNetwork(groupTypeCode, isIframe);
        var selectedNetworkCode = rootScope.getSelectedNetworkCode();
        var defaultNetwork = networksService.getNetworkByCode(allNetworks, smartSwitchDefaultCode);
        toggleIcons(smartSwitchDefaultCode, true, false);
        updateLabel(groupTypeCode, null);
        if (smartSwitchDefaultCode != selectedNetworkCode) {
            switchOperations(rootScope.getSelectedNetwork());
            rootScope.setSelectedNetwork(defaultNetwork);
            localize.load(defaultNetwork.links.lang, handleUpdateLang, {
                newNetwork: defaultNetwork,
                rootScope: rootScope,
            });
        }
    }
}
module.exports = {
    toggleIcons: toggleIcons,
    updateLabel: updateLabel,
    handleSmartSwitchForm: handleSmartSwitchForm,
    addSelectedToLi: addSelectedToLi,
};
